module.exports = __webpack_public_path__ + "img/error-postural.69d40dde.png";